import { render, staticRenderFns } from "./OWidgetWrapper.vue?vue&type=template&id=61dd3aa6&scoped=true&"
import script from "./OWidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./OWidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OWidgetWrapper.vue?vue&type=style&index=0&id=61dd3aa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd3aa6",
  null
  
)

export default component.exports